module.exports = __webpack_public_path__ + "img/io-white.b7f425a4.png";